//  import { GridColDef, GridValueGetterParams } from '@material-ui/data-grid'
import { object, string } from 'yup'
import { IBusquedaSkill } from '../../interfaces/Skill/Skill'

export const busquedaInitialState: IBusquedaSkill = {
  skillCode: ''
}

export const createInitialValue = {
  id: 0,
  skillCode: '',
  skillName: '',
  skillDescription: '',
  active: false
}

export const skillValidationSchema = object({
  skillCode: string()
    .trim()
    .required('El campo código de posición es requerido.')
    .min(2, 'Debe ingresar a lo menos 2 caracteres')
    .max(50, 'Máximo 50 caracteres.'),
  skillDescription: string()
    .trim()
    .required('El campo código de posición es requerido.')
    .min(1, 'Debe ingresar a lo menos 3 caracteres')
    .max(200, 'Máximo 200 caracteres.')
})

export const crudActions = {
  canRedirect: false
}
